/**
 *  State for the document permissions store
 *
 * @module Setup
 * @category Store
 * @subcategory Setup
 * @name State
 */

/**
 *  Return default state for setup stored
 *
 * @returns { object} Default state object
 */
export function getDefaultState() {
  return {
    sharingListTypes: {
      student: [],
      teacher: []
    },
    sensitivityLabels: {},
    interfaces: {},
    localeFormats: {}
  };
}

const state = getDefaultState();

export default state;
